async function bootstrapApp() {
    const { initializeI18next, Screen } = await import('shared/services/TranslatorNext/TranslationService');
    await Promise.all([
        initializeI18next(Screen.MAIN_APP),
        import('windowDeps')
    ]);
    await import('app-config')
    const ng = await import('angular');
    ng.bootstrap(document.body, ['vwo']);

    if (import.meta.env.DEV && import.meta.hot) {
        const { initializeVwoHMR } = await import('_hotModuleReloadClient/viteHMR');
        initializeVwoHMR();
    }
}

bootstrapApp();

export {};
